/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {TokenType} from './TokenType';
import {SignedAccountNameDTO} from '../../generated/iam-client';

class LocalStorage {

	setToken(tokenType: TokenType, accountName: string, nonce: string, signature: string): void {
		localStorage.setItem(
			createKey(tokenType, accountName, tokenType !== TokenType.REMEMBER_ME),
			JSON.stringify({accountName, nonce, signature})
		);
	}

	removeToken(tokenType: TokenType, accountName: string | null): void {
		localStorage.removeItem(createKey(tokenType, accountName, accountName !== null));
	}

	getToken(tokenType: TokenType, accountName: string | null): SignedAccountNameDTO | undefined {
		const tokenString = localStorage.getItem(createKey(tokenType, accountName, accountName !== null));
		if (tokenString !== null)
			return JSON.parse(tokenString);
		return undefined;
	}
}

const createKey = (tokenType: TokenType, accountName: string | null, withAccountNameKey: boolean): string => {
	return tokenType + (withAccountNameKey ? '_' + accountName : '');
};

export default LocalStorage;
